import { syncedGet, syncedSet } from '../data/serverStore';
// Editable dropdown lists — persisted in localStorage
// All lists can be managed from the UI without touching code

const KEYS = {
  testCategories: 'sl_list_testcategories',
  sampleForms: 'sl_list_sampleforms',
  sources: 'sl_list_sources',
  technicians: 'sl_list_technicians',
};

const DEFAULTS = {
  testCategories: [
    'Specific Analysis','NPDES','Aquatic Toxicity','Wells','TCLP',
    'Fuel','QA/QC','Coal','Stormwater','Industrial Wastewater',
    'Drinking Water','Soil/Sediment','Air Quality','Tissue',
  ],
  sampleForms: [
    'Aqueous','Solid','Oil','Fuel','Air','Tissue','Sludge','Soil',
    'Sediment','Wipe','Filter','Gas','Coal','Ash',
  ],
  sources: [
    'Relco Compliance Services','S & W Services','MMWEC',
    'Alpha Analytical','Dartmouth College','Incom, Inc.',
    'Ryegate','AIR TOX','Trashology','BWT Pharma',
    'Gammie Air','Phoenix','TRC','R.I. Analytical',
    'Ash Grove Cement',
  ],
  technicians: ['apex','dfp','jdp','kap','rlm','tbs'],
};

function load(key, fallback) {
  try {
    const v = (syncedGet(key, null) !== null ? JSON.stringify(syncedGet(key, null)) : null);
    return v ? JSON.parse(v) : fallback;
  } catch { return fallback; }
}

function save(key, val) {
  try { syncedSet(key, val); } catch {}
}

// Seed defaults on first load
function seed() {
  Object.entries(KEYS).forEach(([name, key]) => {
    if ((syncedGet(key, null) !== null ? JSON.stringify(syncedGet(key, null)) : null) === null) {
      save(key, DEFAULTS[name]);
    }
  });
}
seed();

export const lists = {
  // ── Getters ──
  getTestCategories: () => load(KEYS.testCategories, DEFAULTS.testCategories),
  getSampleForms:    () => load(KEYS.sampleForms, DEFAULTS.sampleForms),
  getSources:        () => load(KEYS.sources, DEFAULTS.sources),
  getTechnicians:    () => load(KEYS.technicians, DEFAULTS.technicians),

  // ── Setters ──
  setTestCategories: (arr) => save(KEYS.testCategories, arr),
  setSampleForms:    (arr) => save(KEYS.sampleForms, arr),
  setSources:        (arr) => save(KEYS.sources, arr),
  setTechnicians:    (arr) => save(KEYS.technicians, arr),

  // ── Add item ──
  addTo(listName, value) {
    const trimmed = value.trim();
    if (!trimmed) return false;
    const key = KEYS[listName];
    const arr = load(key, []);
    if (arr.map(x => x.toLowerCase()).includes(trimmed.toLowerCase())) return false; // duplicate
    arr.push(trimmed);
    arr.sort((a, b) => a.localeCompare(b));
    save(key, arr);
    return true;
  },

  // ── Remove item ──
  removeFrom(listName, value) {
    const key = KEYS[listName];
    const arr = load(key, []).filter(x => x !== value);
    save(key, arr);
  },

  // ── Rename item ──
  renameIn(listName, oldVal, newVal) {
    const trimmed = newVal.trim();
    if (!trimmed) return false;
    const key = KEYS[listName];
    const arr = load(key, []).map(x => x === oldVal ? trimmed : x);
    save(key, arr);
    return true;
  },

  // ── Reset to defaults ──
  resetList(listName) {
    save(KEYS[listName], DEFAULTS[listName]);
  },

  // ── All list metadata for the editor UI ──
  ALL_LISTS: [
    { key: 'testCategories', label: 'Test Categories',   icon: '🧪', description: 'Test category options shown in Sample Receiving' },
    { key: 'sampleForms',    label: 'Sample Forms',      icon: '🧫', description: 'Sample form/matrix options (Aqueous, Solid, etc.)' },
    { key: 'sources',        label: 'Sources & Clients', icon: '🏢', description: 'Client / source company names for quick selection' },
    { key: 'technicians',    label: 'Technicians',       icon: '👤', description: 'Technician codes / names' },
  ],
};
